import { render, staticRenderFns } from "./PermissionsCheckboxes.vue?vue&type=template&id=5e4a83c0&scoped=true"
import script from "./PermissionsCheckboxes.vue?vue&type=script&lang=js"
export * from "./PermissionsCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCheckboxes.vue?vue&type=style&index=0&id=5e4a83c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a83c0",
  null
  
)

export default component.exports